import { App } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import { SplashScreen } from '@capacitor/splash-screen'
import { StatusBar, Style } from '@capacitor/status-bar'

/** Só roda dentro do app nativo; no navegador é um no-op. */
export async function iniciarNativo(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return

  try {
    await StatusBar.setStyle({ style: Style.Dark })
    if (Capacitor.getPlatform() === 'android') {
      await StatusBar.setBackgroundColor({ color: '#2B3455' })
    }
  } catch {
    // StatusBar não existe em todas as plataformas; não é motivo para travar o boot.
  }

  // Botão voltar do Android: navega no histórico e só sai do app na raiz.
  await App.addListener('backButton', ({ canGoBack }) => {
    if (canGoBack) window.history.back()
    else void App.exitApp()
  })

  await SplashScreen.hide()
}
